module.exports = __webpack_public_path__ + "img/clap-colored-icon.4f8142f8.svg";